import { createFileRoute, useNavigate, useLocation } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { ChatView } from '../components/chat/ChatView';
import { Breadcrumb } from '../components/Breadcrumb';
import { useFeatures } from '../hooks/useFeatures';
import { usePermissions } from '../hooks/usePermissions';
import { usePermissionDeniedStore } from '../stores/permissionDenied.store';
import api from '../lib/api';

export const Route = createFileRoute('/w/$workspaceId/chat')({
  component: ChatPage,
});

function ChatPage() {
  const { workspaceId } = Route.useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { isChatEnabled } = useFeatures();
  const { hasPermission, isLoading: isLoadingPermissions } = usePermissions();
  const showPermissionDenied = usePermissionDeniedStore((state) => state.show);
  const canView = hasPermission('chat.view');

  useEffect(() => {
    if (!location.pathname.startsWith('/w/')) return;
    if (!isLoadingPermissions && !canView) {
      showPermissionDenied('Ver chat');
      navigate({ to: '/w/$workspaceId/clients', params: { workspaceId } });
    }
  }, [location.pathname, isLoadingPermissions, canView, showPermissionDenied, navigate, workspaceId]);

  const { data: workspace } = useQuery({
    queryKey: ['workspaces', workspaceId],
    queryFn: async () => {
      const response = await api.get(`/workspaces/${workspaceId}`);
      return response.data.data;
    },
    enabled: !!workspaceId && (isLoadingPermissions || canView),
  });

  if (!isChatEnabled) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Funcionalidade Desativada</h1>
          <p className="text-gray-600">A funcionalidade de Chat está temporariamente desativada.</p>
        </div>
      </div>
    );
  }

  if (!isLoadingPermissions && !canView) return null;

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex flex-col">
      <div
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col w-full"
        style={{ height: 'calc(100vh - 96px)', minHeight: 0 }}
      >
        <Breadcrumb
          items={[
            { label: workspace?.name || 'Workspace', to: '/w/$workspaceId/clients', params: { workspaceId } },
            { label: 'Chat' },
          ]}
        />
        <div
          className="flex-1 flex mt-6 w-full min-h-0 overflow-hidden"
        >
          <ChatView workspaceId={workspaceId} />
        </div>
      </div>
    </div>
  );
}

